<template>
    <div class="money">
        <nav class="money-nav">
            <div class="money-nav-item" style="flex: 4">时间</div>
            <div class="money-nav-item" style="flex: 3">提现金额</div>
            <div class="money-nav-item" style="flex: 3">状态</div>
        </nav>
        <div class="empty-data" v-if="!haveData">
            <div>
                <i class="iconfont icon-similarproduct"></i>
            </div>
            <div>
                <p>暂无数据</p>
            </div>
        </div>
        <div class="money-content" v-for="item in list" :key="item._id">
            <div class="money-content-item" style="flex: 4">{{item.time}}</div>
            <div class="money-content-item" style="flex: 3">{{item.moneyStr}}</div>
            <div class="money-content-item" style="flex: 3">{{item.statusStr}}</div>
        </div>
        <div class="weui-footer" v-if="!haveData">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import weui from "weui.js";

export default {
  data() {
    return {
      haveData: true,
      year: moment().format("YYYY"),
      list: []
    };
  },
  created() {
    let encodeToken = this.$route.params.token;
    let token = decodeURIComponent(encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + token;

    // 根据token查找微信用户信息
    axios
      .get("/api/takecash/wxlist")
      .then(res => {
        if (res.data.success) {
          this.list = res.data.data;
          if (this.list.length == 0) {
            this.haveData = false;
          } else {
            for (let i = 0; i < this.list.length; i++) {
              this.list[i].time = moment(this.list[i].createdAt).format(
                "YYYY-MM-DD HH:mm"
              );
              this.list[i].moneyStr = this.list[i].money / 100 + ' 元';
              if(this.list[i].status == 0) {
                  this.list[i].statusStr = "待审核";
              }else if(this.list[i].status == 1) {
                  this.list[i].statusStr = "审核通过";
              }else if(this.list[i].status == 2) {
                  this.list[i].statusStr = "审核不通过";
              }else if(this.list[i].status == 100) {
                  this.list[i].statusStr = "已转账";
              }
            }
          }
        } else {
          weui.alert("获取提现列表失败");
        }
      })
      .catch(error => {
        weui.alert("获取提现列表失败");
      });
  }
};
</script>

<style scoped>
.money {
  font-size: 14px;
  margin: 0 auto;
  text-align: center;
}
.money-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  margin-bottom: 10px;
}
.money-nav-item {
  flex: 1;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
  font-weight: bold;
}
.money-nav-item:last-child {
  border-right: none;
}
.money-content {
  display: flex;
  height: 40px;
  line-height: 40px;
  border-top: 1px solid #eee;
}
.money-content + .money-content {
  border-top: none;
}
.money-content:nth-child(2n) {
  background-color: #f0f0f0;
}
.money-content-item {
  flex: 1;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.money-content-item:last-child {
  border-right: none;
}
.add {
  color: #1aad19;
}
.reduce {
  color: orangered;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/infos/TakecashList.vue